// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.reporting.admin.AccessLogSearchResponse */
/* istanbul ignore next */
@GandalfModel
export class AccessLogSearchResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	duration!: number | null;

	@GandalfProperty({ designType: Boolean })
	emergencyAccess!: boolean | null;

	@GandalfProperty({ designType: Date })
	endDate!: Date | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Date })
	startDate!: Date | null;

	@GandalfProperty({ designType: Number })
	userId!: number | null;

	@GandalfProperty({ designType: String })
	userName!: string | null;

}
